export const TOGGLE_LAYER = 'TOGGLE_LAYER'
export const SET_OPACITY = 'SET_OPACITY'
export const SET_BASEMAP = 'SET_BASEMAP'

export const setBasemap = basemap => {
    return {
        type: SET_BASEMAP,
        basemap
    }
}

export const setOpacity = (layer, opacity) => {
    return {
        type: SET_OPACITY,
        layer,
        opacity
    }
}

export const toggleLayer = layer => {
    return {
        type: TOGGLE_LAYER,
        layer
    }
}
